import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-comments-dialog",
    templateUrl: "./comments-dialog.component.html",
    styleUrls: ["./comments-dialog.component.scss"],
})
export class CommentsDialogComponent implements OnInit {
    commentsData: any;

    constructor(
        public dialogRef: MatDialogRef<CommentsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
        this.commentsData = this.data.comments;
        // console.log(this.commentsData);
    }

    getFirstLetter(name: string): string {
        if (!name) return "";
        return name.trim().charAt(0).toUpperCase();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    formatTimestamp(timestamp: string | number | Date): string {
        if (!timestamp) return "";

        // Convert string to number if needed
        const ts =
            typeof timestamp === "string" ? parseInt(timestamp, 10) : timestamp;

        const date = new Date(ts);
        if (isNaN(date.getTime())) return ""; // safeguard against invalid values

        const options: Intl.DateTimeFormatOptions = {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        };

        return new Intl.DateTimeFormat("en-GB", options)
            .format(date)
            .replace(",", " |");
    }

    getUserColor(name: string): string {
        if (!name) return "#E0E0E0"; 

        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }

        const colors = [
            "#FFB6C1",
            "#FFD580",
            "#87CEFA",
            "#90EE90",
            "#DDA0DD",
            "#FFE4B5",
        ];
        return colors[Math.abs(hash) % colors.length];
    }
}
